'use strict';

define(['debounce', 'viewport'], function (debounce, viewport) {
  var ColumboEvents = function ColumboEvents() {
    var module = {};

    var _config = {
      constants: {
        DEBOUNCE_TIMEOUT: 500
      },
      selectors: {
        viewedElements: '[data-component-tracked-viewed]',
        clickedElements: '[data-component-tracked-clicked]',
        focusedElements: '[data-component-tracked-focused]',
        hoveredElements: '[data-component-tracked-hovered]'
      }
    };

    var _init = function _init() {
      module.viewedElements = Array.from(document.querySelectorAll(module.config.selectors.viewedElements));
      module.clickedElements = Array.from(document.querySelectorAll(module.config.selectors.clickedElements));
      module.focusedElements = Array.from(document.querySelectorAll(module.config.selectors.focusedElements));
      module.hoveredElements = Array.from(document.querySelectorAll(module.config.selectors.hoveredElements));
      module.trackedElementsConfig = module.getTrackedElementsConfig();
    };

    var _getTrackedElementsConfig = function _getTrackedElementsConfig() {
      return module.viewedElements.map(function (element) {
        return module.getNewConfigObj(element);
      });
    };

    var _createCustomDivSpies = function _createCustomDivSpies(spiesConfig) {
      spiesConfig.forEach(function (spyConfig) {
        var customDivs = Array.from(document.querySelectorAll(spyConfig.trigger.className));
        customDivs.forEach(function (customDivs) {
          customDivs.addEventListener('scroll', debounce(function () {
            return module.addTracking(module.focusCallback, module.blurCallback);
          }, module.config.constants.DEBOUNCE_TIMEOUT));
          customDivs.addEventListener('resize', debounce(function () {
            return module.addTracking(module.focusCallback, module.blurCallback);
          }, module.config.constants.DEBOUNCE_TIMEOUT));
        });
      });
    };

    var _getDiffElements = function _getDiffElements(newArray, basedArray) {
      return basedArray.filter(function (element) {
        if (newArray.indexOf(element) === -1) {
          return element;
        }
      });
    };

    var _updateViewedConfig = function _updateViewedConfig() {
      module.maybeNewViewedElements = Array.from(document.querySelectorAll(module.config.selectors.viewedElements));
      var maybeNewViewedElements = module.getDiffElements(module.viewedElements, module.maybeNewViewedElements);

      if (maybeNewViewedElements.length !== 0) {
        maybeNewViewedElements.forEach(function (element) {
          var obj = module.getNewConfigObj(element);
          module.trackedElementsConfig.push(obj);
          module.viewedElements.push(element);
        });
        module.addTracking(module.focusCallback, module.blurCallback);
      }
    };

    var _deepClone = function _deepClone(obj) {
      return JSON.parse(JSON.stringify(obj));
    };

    var _getContext = function _getContext(element) {
      var context = element.getAttribute('data-context');
      return context ? context : '';
    };

    // Required for bot filtering
    var _getClassName = function _getClassName(element) {
      return element.className.split(' ')[0];
    };

    var _getData = function _getData(element) {
      return {
        subtype: module.getClassName(element),
        is_interaction: false,
        contents: [{ html_element: module.getContext(element) }],
        viewport_width: Math.round(viewport.getMaxClientOrInnerWidth()),
        viewport_height: Math.round(viewport.getMaxClientOrInnerHeight()),
        from_viewport_top: Math.round(viewport.getFromViewportTop(element)),
        from_viewport_left: Math.round(viewport.getFromViewportLeft(element))
      };
    };

    var _addElementClickedTracking = function _addElementClickedTracking(elements, elementClickedConfig, publishEvent) {
      elements.forEach(function (element) {
        var data = module.getData(element);
        data.type = 'click';
        element.addEventListener('click', function () {
          return publishEvent(elementClickedConfig, data);
        });
      });
    };

    var _findNewClickedTracking = function _findNewClickedTracking(elementClickedConfig, publishEvent) {
      module.maybeNewClickedElements = Array.from(document.querySelectorAll(module.config.selectors.clickedElements));
      var maybeNewClickedElements = module.getDiffElements(module.clickedElements, module.maybeNewClickedElements);
      if (maybeNewClickedElements.length !== 0) {
        module.addElementClickedTracking(maybeNewClickedElements, elementClickedConfig, publishEvent);
      }
    };

    var _elementClicked = function _elementClicked(elementClickedConfig, publishEvent) {
      module.findNewClickedTracking(elementClickedConfig, publishEvent);
      module.addElementClickedTracking(module.clickedElements, elementClickedConfig, publishEvent);
      window.setInterval(module.findNewClickedTracking, module.config.constants.DEBOUNCE_TIMEOUT);
    };

    var _getNewConfigObj = function _getNewConfigObj(element) {
      var obj = {};
      obj.element = element;
      obj.isViewed = false;
      obj.isFirstTimeSeen = true;
      return obj;
    };

    var _getDisplayProperty = function _getDisplayProperty(element) {
      return element ? window.getComputedStyle(element).getPropertyValue('display') : null;
    };

    var _sendFocusEvent = function _sendFocusEvent(config, data, isElementDisplayable, publishCallbackFocus) {
      config.isFirstTimeSeen = false;
      config.isViewed = true;
      config.isElementDisplayable = isElementDisplayable;
      data.type = 'focus';
      publishCallbackFocus(data);
    };

    var _sendBlurEvent = function _sendBlurEvent(config, data, isElementDisplayable, publishCallbackBlur) {
      config.isElementDisplayable = isElementDisplayable;
      config.isViewed = false;
      data.type = 'blur';
      publishCallbackBlur(data);
    };

    var _isElementDisplayable = function _isElementDisplayable(trackedElement) {
      var displayProperty = module.getDisplayProperty(trackedElement);
      var parentDisplayProperty = module.getDisplayProperty(trackedElement.parentNode);
      var isDisplayable = displayProperty !== '' && displayProperty !== 'none';
      var isParentDisplayable = parentDisplayProperty !== '' && parentDisplayProperty !== 'none';
      return isDisplayable && isParentDisplayable;
    };

    var _getFocusCallback = function _getFocusCallback(elementViewedConfig, publishEvent) {
      var configElementFocus = module.deepClone(elementViewedConfig);
      configElementFocus.key += 'Focus';
      configElementFocus.publish.event += '-focus';
      return function (data) {
        publishEvent(configElementFocus, data);
      };
    };

    var _getBlurCallback = function _getBlurCallback(elementViewedConfig, publishEvent) {
      var configElementBlur = module.deepClone(elementViewedConfig);
      configElementBlur.key += 'Blur';
      configElementBlur.publish.event += '-blur';
      return function (data) {
        publishEvent(configElementBlur, data);
      };
    };

    var _addTracking = function _addTracking(focusCallback, blurCallback) {
      module.trackedElementsConfig.forEach(function (config) {
        var trackedElement = config.element;
        var isElementDisplayable = module.isElementDisplayable(trackedElement);
        var data = module.getData(trackedElement);

        if (config.isElementDisplayable && !isElementDisplayable) {
          module.sendBlurEvent(config, data, isElementDisplayable, blurCallback);
        }

        if (isElementDisplayable) {
          var isElementInTheViewport = viewport.isElementVisible(trackedElement);

          if (isElementInTheViewport && !config.isViewed) {
            module.sendFocusEvent(config, data, isElementDisplayable, focusCallback);
          }

          if (!isElementInTheViewport && config.isViewed && !config.isFirstTimeSeen) {
            module.sendBlurEvent(config, data, isElementDisplayable, blurCallback);
          }
        }
      });
    };

    var _elementViewed = function _elementViewed(elementViewedConfig, publishEvent) {
      module.focusCallback = module.getFocusCallback(elementViewedConfig, publishEvent);
      module.blurCallback = module.getBlurCallback(elementViewedConfig, publishEvent);

      if (document.readyState === 'complete') {
        module.addTracking(module.focusCallback, module.blurCallback);
      } else {
        window.addEventListener('load', function () {
          return module.addTracking(module.focusCallback, module.blurCallback);
        });
      }
      window.addEventListener('scroll', debounce(function () {
        return module.addTracking(module.focusCallback, module.blurCallback);
      }, module.config.constants.DEBOUNCE_TIMEOUT));
      window.addEventListener('resize', debounce(function () {
        return module.addTracking(module.focusCallback, module.blurCallback);
      }, module.config.constants.DEBOUNCE_TIMEOUT));
      window.setInterval(module.updateViewedConfig, module.config.constants.DEBOUNCE_TIMEOUT);
    };

    var _elementFocused = function _elementFocused(config, publish) {
      module.focusedElements.map(function (element) {
        var focusData = module.getData(element);
        var blurData = module.getData(element);

        focusData.type = 'focus';
        blurData.type = 'blur';

        element.addEventListener('focus', function () {
          return publish(config, focusData);
        });
        element.addEventListener('blur', function () {
          return publish(config, blurData);
        });
      });
    };

    var _elementHovered = function _elementHovered(config, publish) {
      module.hoveredElements.map(function (element) {
        var enterData = module.getData(element);
        var exitData = module.getData(element);

        enterData.type = 'mouseenter';
        exitData.type = 'mouseleave';

        element.addEventListener('mouseenter', debounce(function () {
          return publish(config, enterData);
        }, module.config.constants.DEBOUNCE_TIMEOUT));
        element.addEventListener('mouseleave', debounce(function () {
          return publish(config, exitData);
        }, module.config.constants.DEBOUNCE_TIMEOUT));
      });
    };

    module.init = _init;
    module.config = _config;
    module.addElementClickedTracking = _addElementClickedTracking;
    module.addTracking = _addTracking;
    module.createCustomDivSpies = _createCustomDivSpies;
    module.elementViewed = _elementViewed;
    module.elementClicked = _elementClicked;
    module.elementFocused = _elementFocused;
    module.elementHovered = _elementHovered;
    module.deepClone = _deepClone;
    module.findNewClickedTracking = _findNewClickedTracking;
    module.getBlurCallback = _getBlurCallback;
    module.getData = _getData;
    module.getContext = _getContext;
    module.getClassName = _getClassName;
    module.getNewConfigObj = _getNewConfigObj;
    module.getDisplayProperty = _getDisplayProperty;
    module.getDiffElements = _getDiffElements;
    module.getFocusCallback = _getFocusCallback;
    module.getTrackedElementsConfig = _getTrackedElementsConfig;
    module.isElementDisplayable = _isElementDisplayable;
    module.sendFocusEvent = _sendFocusEvent;
    module.sendBlurEvent = _sendBlurEvent;
    module.updateViewedConfig = _updateViewedConfig;

    module.init();

    return module;
  };

  return ColumboEvents;
});
//# sourceMappingURL=columbo-events.js.map
